<template>
  <v-container fluid pa-0>
    <v-card tile flat>
      <v-card-title>
        <v-menu
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              rounded
              single-line
              dense
              filled
              hide-details
              label="Datum"
              v-model="date"
              v-on="on"
              v-bind="attrs"
              readonly
              prepend-inner-icon="mdi-calendar-range"
              class="mr-4"
            ></v-text-field>
          </template>
          <v-date-picker first-day-of-week="1" v-model="date"></v-date-picker>
        </v-menu>

        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          label="Sök..."
          rounded
          single-line
          dense
          filled
          hide-details
        ></v-text-field>
        <v-spacer />
        <v-dialog v-model="showCreateModal" width="600" persistent scrollable>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" rounded color="primary">
              <v-icon small class="pr-4">mdi-plus-circle-outline</v-icon>
              Skapa Banner
            </v-btn>
          </template>
          <TibBannerCreateModal
            v-if="showCreateModal"
            @close="showCreateModal = false"
            @reload="fetchAll"
          />
        </v-dialog>
        <v-dialog v-model="showEditModal" width="600" persistent scrollable>
          <TibBannerEditModal
            v-if="showEditModal"
            @close="showEditModal = false"
          />
        </v-dialog>
        <v-dialog v-model="showDeleteModal" width="300" persistent scrollable>
          <TibBannerDeleteModal
            v-if="showDeleteModal"
            @close="showDeleteModal = false"
          />
        </v-dialog>
      </v-card-title>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="data"
        :search="search"
        :sort-by="sortBy"
        :sort-desc="sortDesc"
        hide-default-footer
        disable-pagination
        fixed-header
        :height="tableHeight"
      >
        <template v-slot:item._actions="{ item }">
          <v-menu left>
            <template #activator="{ attrs, on }">
              <v-btn v-bind="attrs" v-on="on" icon>
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <template v-for="(actionItem, $i) in actionItems">
                <v-list-item :key="$i" @click="actionItem.action(item)">
                  <v-list-item-icon>
                    <v-icon small v-text="actionItem.icon"></v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>
                      {{ actionItem.title }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import inputTableHeight from '@/mixins/inputTableHeight'
import TibBannerCreateModal from './TibBannerCreateModal'
import TibBannerEditModal from './TibBannerEditModal'
import TibBannerDeleteModal from './TibBannerDeleteModal'
import orderBy from 'lodash.orderby'
import { format } from 'date-fns'
import { get, sync } from 'vuex-pathify'

const headers = [
  {
    text: 'Från',
    value: '_time_start'
  },
  {
    text: 'Till',
    value: '_time_end'
  },

  {
    text: 'Titel',
    value: 'title'
  },

  {
    text: 'Tågnr.',
    value: 'train'
  },

  {
    text: 'Orsak',
    value: 'reason'
  },

  {
    text: 'Meddelande',
    value: 'text'
  },

  {
    text: 'Skapad',
    value: '_created'
  },

  {
    text: '',
    value: '_actions'
  }
]

export default {
  name: 'TibBannerTable',

  components: {
    TibBannerCreateModal,
    TibBannerEditModal,
    TibBannerDeleteModal
  },

  mixins: [inputTableHeight(187)],

  watch: {
    date: 'fetchAll'
  },

  created() {
    this.fetchAll()
  },

  data() {
    return {
      showCreateModal: false,
      showEditModal: false,
      showDeleteModal: false,
      headers,
      search: '',
      sortDesc: true,
      sortBy: 'created',
      loading: false
    }
  },

  computed: {
    date: sync('tibBanner/filter@date'),
    tibBannerData: get('tibBanner/data'),
    data() {
      return orderBy(
        this.tibBannerData.map(x => ({
          ...x,
          _time_start: format(new Date(x.time_start), 'yyyy-MM-dd HH:mm'),
          _time_end: format(new Date(x.time_end), 'yyyy-MM-dd HH:mm'),
          _created: format(new Date(x.created), 'yyyy-MM-dd HH:mm')
        })),
        ['created'],
        ['asc']
      )
    },

    actionItems() {
      return [
        {
          title: 'Redigera',
          icon: 'mdi-pencil',
          action: row => {
            this.$store.dispatch('tibBanner/editModel', row)
            this.showEditModal = true
          }
        },
        {
          title: 'Ta bort',
          icon: 'mdi-delete',
          action: row => {
            this.$store.dispatch('tibBanner/editModel', row)
            this.showDeleteModal = true
          }
        }
      ]
    }
  },

  methods: {
    async fetch() {
      return this.$store.dispatch('tibBanner/fetch', this.date)
    },

    async fetchAll() {
      this.loading = true
      await this.fetch()
      this.loading = false
    }
  }
}
</script>

<style lang="scss" module>
.proposalRow {
  background: rgba(blue, 0.08);
}
</style>
